var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentUser)?_c('Toolbar'):_vm._e(),(_vm.currentUser)?_c('NavigationDrawer'):_vm._e(),_c('ConfirmDialog'),_c('Snackbar'),_c('v-main',{staticClass:"transition-none"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }